import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateRolePermission, getDeptUser, getRoleUsers, getListRoleUsers, saveRoleUsers, getRoleUserTypes, saveRoleUserTypes } from "@/api/system/role";
import { getListTableUrl } from "@/api/management/user";
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
import { mapGetters, mapMutations } from "vuex";
import treeMenu from "@/components/treeMenu/index.vue";
export default {
  name: "userPermissionType",
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      userName: "",
      deptUserData: [],
      selectUser: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      chooseAll: false,
      multipleDeptUser: [],
      preMultipleDeptUser: [],
      currentDeptId: 1,
      selectedRoleUsers: [],
      // selectedRoleUsersArray: [],
      userTypeChecked: [],
      utypesArray: [],
      treeKey: Date.parse(new Date()),
      dealRoleType: dealRoleType,
      dealRoleTypeData: dealRoleTypeData,
      stringToArray: stringToArray,
      dialogWidth: "500px",
      isCheckBoxInit: true,
      selectedUserListArr: [],
      loading: false
    };
  },
  components: {
    treeMenu: treeMenu
  },
  computed: _objectSpread({}, mapGetters(["userPermissionTypeDialog", "permissionDialog", "checkedArray", "userTypes"])),
  watch: {
    permissionDialog: function permissionDialog(val) {
      this.treeKey = Date.parse(new Date());
      this.currentDeptId = 1;
      this.$store.commit("clearChecked");
      this.selectedRoleUsers = [];
      this.selectedUserListArr = [];
      this.selectUser.current = 1;
      console.log(333, this.selectUser.current); // this.selectedRoleUsersArray=[];

      if (val && this.userPermissionTypeDialog.promptType === "permission") {
        this.dialogWidth = "500px";
        this.isCheckBoxInit = true;
      }

      if (this.userPermissionTypeDialog.promptType !== "permission") {
        this.dialogWidth = "1050px";
      }
    }
  },
  created: function created() {},
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setPermissionDialog: "setPermissionDialog",
    setDefaultChecked: "setDefaultChecked"
  })), {}, {
    handleDialogClose: function handleDialogClose() {
      this.setPermissionDialog(false);
    },
    modifysubmit: function modifysubmit() {
      var _this = this;

      console.log(44, this.checkedArray);

      if (this.checkedArray.length < 1) {
        this.$message.error("未选择权限不能进行保存！");
        return;
      }

      var roleId = this.userPermissionTypeDialog.currentRoleId;
      var menuIds = this.checkedArray;
      var query = {
        roleId: roleId,
        menuIds: menuIds
      };
      updateRolePermission(query).then(function (res) {
        if (res.data.code == 0) {
          _this.$message.success("修改权限成功");

          _this.$parent.getTableData();

          _this.setPermissionDialog(false);
        }
      });
    },
    // updateRoleUser() {
    //   const roleId = this.userPermissionTypeDialog.currentRoleId;
    //   const deptId = this.currentDeptId;
    //   const all = this.chooseAll;
    //   const users = this.multipleDeptUser;
    //   saveRoleUsers({ roleId, deptId, all, users }).then(res => {
    //     if (res.data.code == 0) {
    //       this.$message.success("选择用户成功");
    //       this.setPermissionDialog(false);
    //     }
    //   });
    // },
    getNodeId: function getNodeId(data) {
      this.currentDeptId = data.id;
      this.selectUser.current = 1;
      this.getDeptUserData();
    },
    userSearch: function userSearch() {
      this.selectUser.current = 1;
      this.getDeptUserData();
    },
    clearUserName: function clearUserName() {
      this.userName = "";
      this.getDeptUserData();
    },
    handleSelect: function handleSelect(selection, row) {
      var _this2 = this;

      console.log(row);
      this.multipleDeptUser = selection; // console.log(this.multipleDeptUser.length,this.preMultipleDeptUser.length)

      if (!selection.includes(row)) {
        var index = this.selectedRoleUsers.findIndex(function (e) {
          return e == String(row.userId);
        });
        this.selectedRoleUsers.splice(index, 1);
        this.selectedUserListArr.splice(index, 1); // console.log(index,this.selectedRoleUsers)
      } else {
        this.multipleDeptUser.forEach(function (item, index) {
          if (!_this2.selectedRoleUsers.includes(String(item.userId))) {
            _this2.selectedRoleUsers.push(String(item.userId));

            _this2.selectedUserListArr.push(item);
          }
        });
      } // console.log("切换选择后",this.selectedRoleUsers)

    },
    selectionChange: function selectionChange(val) {
      this.chooseAll && (this.chooseAll = false);
    },
    allSelectionChange: function allSelectionChange(selection) {
      var _this3 = this;

      if (selection.length > 0) {
        this.chooseAll = true;
        selection.forEach(function (item, index) {
          if (!_this3.selectedRoleUsers.includes(String(item.userId))) {
            _this3.selectedRoleUsers.push(String(item.userId));

            _this3.selectedUserListArr.push(item);
          }
        });
      } else {
        this.chooseAll = false;
        this.deptUserData.forEach(function (item, index) {
          var filterIndex = _this3.selectedRoleUsers.findIndex(function (e) {
            return e == item.userId;
          });

          _this3.selectedRoleUsers.splice(filterIndex, 1);

          _this3.selectedUserListArr.splice(filterIndex, 1);
        });
      }

      console.log(999, this.selectedUserListArr, selection, this.selectedRoleUsers);
    },
    UserCurrentChange: function UserCurrentChange(val) {
      this.selectUser.current = val;
      this.getDeptUserData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.selectUser.pageSize = val;
      this.getDeptUserData();
    },
    // 删除被选中的用户
    delSelectedUser: function delSelectedUser(row) {
      var _this4 = this;

      // console.log("删除用户：",row)
      var selectIndex = this.selectedUserListArr.findIndex(function (e) {
        return e === row;
      });
      this.selectedRoleUsers.splice(selectIndex, 1);
      this.selectedUserListArr.splice(selectIndex, 1);
      var rowId = row.directorId || row.userId;
      this.deptUserData.forEach(function (item) {
        if (item.userId == rowId) {
          _this4.$refs.multipleRoleUserTable.toggleRowSelection(item, false);
        }
      });
    },
    getRoleUsersData: function getRoleUsersData() {
      var _this5 = this;

      var roleId = this.userPermissionTypeDialog.currentRoleId;
      this.loading = true;
      getListRoleUsers({
        roleId: roleId
      }).then(function (res) {
        if (res.data.code == 0) {
          var data = res.data.data;
          var idArr = data.map(function (item) {
            return String(item.userId);
          });
          _this5.selectedRoleUsers = idArr;
          _this5.selectedUserListArr = data; // this.selectedRoleUsersArray = res.data.data;

          _this5.getDeptUserData();
        }
      }).catch(function () {
        _this5.loading = false;
      });
    },
    getDeptUserData: function getDeptUserData() {
      var _this6 = this;

      var current = this.selectUser.current;
      var size = this.selectUser.pageSize;
      var deptId = this.currentDeptId;
      var type = this.type == 0 ? 2 : 0;
      var params = {
        current: current,
        size: size,
        deptId: deptId,
        type: type
      };

      if (this.userName) {
        params.userName = this.userName;
      }

      getListTableUrl(params).then(function (res) {
        if (res.data.code == 0) {
          _this6.deptUserData = res.data.data.records;
          _this6.selectUser.total = res.data.data.total;

          _this6.$nextTick(function () {
            _this6.deptUserData.forEach(function (row) {
              if (_this6.selectedRoleUsers.includes(String(row.userId))) {
                _this6.$refs.multipleRoleUserTable.toggleRowSelection(row, true);
              }
            });
          });
        }
      }).finally(function () {
        _this6.loading = false;
      });
    },
    updateRoleUser: function updateRoleUser() {
      var _this7 = this;

      var roleId = this.userPermissionTypeDialog.currentRoleId;
      var deptId = this.currentDeptId;
      var all = this.chooseAll; // const users = this.multipleDeptUser;

      var users = this.selectedRoleUsers;

      if (users.length < 1) {
        this.$message.closeAll();
        this.$message.warning("请选择用户");
        return;
      }

      saveRoleUsers({
        roleId: roleId,
        deptId: deptId,
        all: all,
        users: users
      }).then(function (res) {
        if (res.data.code == 0) {
          _this7.$message.success("选择用户成功");

          _this7.setPermissionDialog(false);
        }
      });
    },
    userTypeSelectionChange: function userTypeSelectionChange(val) {
      var selectedArray = val.map(function (item) {
        return item.value;
      });
      this.userTypeChecked = [].concat(selectedArray);
    },
    getRoleUserTypesData: function getRoleUserTypesData() {
      var _this8 = this;

      var roleId = this.userPermissionTypeDialog.currentRoleId;
      getRoleUserTypes({
        roleId: roleId
      }).then(function (res) {
        // console.log("获取用户角色类型数据:", res);
        if (res.data.code == 0) {
          // this.depIdsArray = res.data.data.depIds;
          _this8.utypesArray = res.data.data.utypes;

          _this8.$nextTick(function () {
            _this8.userTypes.forEach(function (row) {
              var checked = _this8.utypesArray.includes(String(row.value)) ? true : false;

              _this8.$refs.multipleRoleUserType.toggleRowSelection(row, checked);
            });

            _this8.setDefaultChecked(res.data.data.depIds);
          });
        }
      });
    },
    updateRoleUserType: function updateRoleUserType() {
      var _this9 = this;

      var roleId = this.userPermissionTypeDialog.currentRoleId;
      var deptIds = this.checkedArray.join(",");
      var usertypes = this.userTypeChecked.join(","); // console.log(111, this.checkedArray);

      if (this.checkedArray.length < 1) {
        this.$message.closeAll();
        this.$message.warning("请选择部门");
        return;
      }

      if (this.userTypeChecked.length < 1) {
        this.$message.closeAll();
        this.$message.warning("请选择用户类型");
        return;
      }

      saveRoleUserTypes({
        roleId: roleId,
        deptIds: deptIds,
        usertypes: usertypes
      }).then(function (res) {
        // console.log("保存用户类型数据：", res);
        if (res.data.code == 0) {
          _this9.$message.success("修改用户类型成功");

          _this9.setPermissionDialog(false);
        }
      });
    }
  })
};